import { render, staticRenderFns } from "./DashboardTransport.vue?vue&type=template&id=530db190&scoped=true"
import script from "./DashboardTransport.vue?vue&type=script&lang=js"
export * from "./DashboardTransport.vue?vue&type=script&lang=js"
import style0 from "./DashboardTransport.vue?vue&type=style&index=0&id=530db190&prod&lang=css"
import style1 from "./DashboardTransport.vue?vue&type=style&index=1&id=530db190&prod&lang=scss"
import style2 from "./DashboardTransport.vue?vue&type=style&index=2&id=530db190&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530db190",
  null
  
)

export default component.exports